<template>
  <!-- 公用组件-选择、新增信息输入框  -->
  <div class="MaInput">
    <el-input id="input1" 
    clearable :disabled="isdisable" ref="input" size="mini" v-model="value1.FullName" @focus="doFocus"  @blur="doBlur" @input="inputText" @keyup.down.native="downkey($event)" @keyup.up.prevent.native="upkey($event)" @keyup.enter.native="enterkey($event)"
    @dblclick.native="searchInfor" @clear="clearData">
        <span slot="prefix" class="label_sty">{{labelName}} :</span>
        <i slot="suffix" v-if="iconAdd" class="el-input__icon el-icon-plus" @click="addShow=true"></i>
        <i slot="suffix" v-if="iconSearch" class="el-input__icon el-icon-search" @click="searchShow=true"></i>
    </el-input>
    <el-popover  placement="top-start"  width="350" trigger="manual" v-model="visible">
        <vxe-table  border  highlight-hover-row  align="center"  highlight-current-row :keyboard-config="{isArrow:true}"  :auto-resize="true"  resizable size="small" ref="xTable"  height="250" :data="tableData" show-overflow show-header-overflow @current-change="currentChangeEvent" @cell-click="clickRow">
          <template v-for="(item,index) in tableHeadData">
            <vxe-table-column :field="item.Key" :title="item.Label" width="100" fixed="left" align="center" v-if="item.Key=='FullName'"  :key="index"></vxe-table-column>
            <vxe-table-column :field="item.Key" :title="item.Label" width="100" fixed="left" align="center" v-else-if="item.Key=='BaseCode'"  :key="index"></vxe-table-column>
            <vxe-table-column :field="item.Key" :title="item.Label" width="100" align="center" v-else  :key="index"></vxe-table-column>
          </template>
        </vxe-table>
    </el-popover>
    <!-- 添加经手人选择弹出框 -->
    <addCustomDialog :show.sync="addShow" v-if="classify=='Client'||classify=='ClientA'||classify=='ClientB'" fieldData="value1" @backData="backData" v-bind="$attrs"/>
    <!-- 添加仓库弹出框 -->
    <addDalog :show.sync="addShow"  v-if="classify=='Stock'" fieldData="value1" @backData="backData" v-bind="$attrs"/>
    <!-- 添加经手人选择弹出框 -->
    <addClerkDialog :show.sync="addShow" v-if="classify=='Person'" fieldData="value1" @backData="backData" v-bind="$attrs"/>
    <!-- 添加地区选择弹出框 -->
    <addAreaDalog :show.sync="addShow" v-if="classify=='Area'" fieldData="value1" @backData="backData" v-bind="$attrs"/>
    <!-- 选择弹出框 -->
    <Searchpop ref="searchpop" :show.sync="searchShow" fieldData="backVal"
      :searchData="searchData" @dbclickRow="chooseBack" v-bind="$attrs" @chooseBack="chooseBack"
    />
  </div>
</template>

<script>
// 引入样板数组
import dataConfig from "@/utils/data.js";
// 工具库
import tool from "@/utils/tool";

export default {
    data() {
        return {
            // 值字段
            value1:this.value,
            oldVal1:{},
            tableHeadData:[],//表格表头数据
            tableData:[],//表格数据
            // 状态字段
            visible:false,//是否显示出模糊收索列表
            cursorMove:true,//聚焦是否可以移动
            rowIndex:0,//行索引
            addShow:false,//新增弹出框是否显示
            searchShow:false,//选择弹出框是否显示
            searchData: {// 传入下一个弹出框的字段，包含标题，树状图url，表格url，过滤url
                title: "",
                url1: "",
                url2: "",
                url3: "",
                type: "",
                classify: ''
            },
        };
    },
    props:{
        // 输入框数据
        value:{
            default:()=>{ return {FullName:'',KtypeId:Number('')} },
            type:Object
        },
        labelName:[String],
        classify:[String],
        isdisable:{
            type:Boolean,
            default:false
        },
        // 添加图标是否显示
        iconAdd:{
            type:Boolean,
            default:true
        },
        // 收索图标是否显示
        iconSearch:{
            type:Boolean,
            default:true
        }
    },
    watch:{
        value:{
            handler:function(newVal,oldVal){
                // console.log(newVal);
                if(newVal.KtypeId != this.oldVal1.KtypeId){
                    this.value1 = newVal;
                    this.oldVal1 = newVal;
                }
            },
            deep:true,//对象内部的属性监听，也叫深度监听
            immediate:true
        },
        // 默认选中表格第一行
        tableData:{
            handler:function(newVal,oldVal){
                if (newVal&&newVal.length>0) {
                    // this.$nextTick(()=>{
                        this.$refs.xTable.setCurrentRow(this.tableData[0]);
                    // })
                }
            },
            deep:true//对象内部的属性监听，也叫深度监听
        }
    },
    methods:{
        // 点击添加
        addInfor(){
            // console.log('点击新增信息')
        },
        // 点击查询
        searchInfor(){
            // console.log('点击查询信息')
            this.searchShow = true;
            this.$refs.input.blur();
        },
        // 按上键
        upkey(e){
            if (!this.visible) {
                this.$emit('preFocus')
            }else{
                if(this.rowIndex!=0){
                    this.rowIndex--;
                }
                this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
                this.$refs.xTable.scrollToRow( this.$refs.xTable.getCurrentRow());
            }
        },
        // 按下键
        downkey(e){
            if (!this.visible) {
                 this.$emit('nextFocus')
            }else{
                if(this.tableData&&this.rowIndex+1<this.tableData.length){
                    this.rowIndex++;
                }
                this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
                this.$refs.xTable.scrollToRow( this.$refs.xTable.getCurrentRow());
            }
        },
        // 回车回调
        enterkey(){
            // 弹出模糊匹配框的时候回调数据
            if (this.visible) {
                if (this.tableData&&this.tableData.length !=0) {
                    // this.$emit('enterkey',this.$refs.xTable.getCurrentRow());
                    this.chooseBack(this.$refs.xTable.getCurrentRow());
                    this.visible = false;
                }else{
                    // this.chooseBack(this.oldVal1);
                }
                return
            }
            // 弹出选择框的时候回调数据
            if (this.searchShow) {
                return
            }
            // 不是选择框和下拉显示框出现的情况下弹出选择框
            this.searchShow = true;
            this.$refs.input.blur();
        },
        // 输入框输入文字
        inputText(text){
            if (text == '') {
                this.value1 = {FullName:'',KtypeId:Number('')}
                // this.value.FullName = this.value.FullName.replace(/^ +| +$/g,'');
                this.visible = false;
            }else{
                this.initListTable(text)
                this.visible = true;
            }
        },
        // 初始化模糊匹配列表数据
        initListTable(Keyword){
            let params= {
                user_id:tool.getLocal("userid"),//用户ID
                session_id:tool.getLocal("sessionid"),//用户凭证
                Keywords:Keyword,//模糊查询参数
                Classify:this.classify,//分类(Goods,Person,Client,ClientA,ClientB,Area,Department,Stock)
                Stoped:0,
            }
            this.request.post('/index/Goods/AllSearch', {'jparams' : JSON.stringify(params)})
            .then(res => {
            // 接收后端发送回来的数据
                this.tableData = res.data;
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 模糊查询时单击行选择数据
        clickRow(row){
            this.chooseBack(row.row);
        },
        //新增弹出框回填数据
        backData(data, fieidName) {
            let typeId = data.KtypeId || data.BtypeId || data.EtypeId;
            this[fieidName].FullName = data.FullName;
            this[fieidName].KtypeId = typeId;
            this.$emit('dateChange',this.value1);
            this.$emit("changeVal");
        },
        //弹出框双击选择回填数据
        chooseBack(data) {
            let typeId;
            if (this.classify=='Client'||this.classify=='ClientA'||this.classify=='ClientB') {
                typeId = data.BtypeId;
            }else if(this.classify=='Stock') {
                typeId = data.KtypeId;
            }else if(this.classify=='Person') {
                typeId = data.EtypeId;
            }
            this.value1.FullName = data.FullName;
            this.value1.KtypeId = typeId;
            this.oldVal1 = {...this.value1};//更新老素值
            this.$emit('dateChange',this.value1);
            this.$emit("changeVal");
            this.$emit('nextFocus');
        },
        // 选中行改变事件
        currentChangeEvent ({ row }) {
        },
        // 聚焦触发全输入框内容
        doFocus() {
            event.currentTarget.select();
            // this.oldVal1 = this.value1;
        },
        // 失去焦点，隐藏选择框
        doBlur(){
            this.visible = false;
            this.rowIndex = 0;//重置索引
            if(this.value1.FullName == ''){
                this.value1 = {FullName:'',KtypeId:Number('')}
            }else{
                this.value1 = {...this.oldVal1};
            }
            // this.$emit('dateChange',this.value1);此处不能绑定事件回调，否则会让报表调单时客户经手人等无法显示
        },
        // 清除数据
        clearData(){
            this.value1 = {FullName:'',KtypeId:Number('')}
            this.$emit('dateChange',this.value1);
        }
    },
    created(){
        switch (this.classify) {
            case 'Client'://客户/供应商
                this.tableHeadData = dataConfig.CustomConfig;
                this.searchData = { 
                    title: "客户/供应商",
                    url1: "/index/Client/getlist",
                    url2: "/index/Client/getAll",
                    url3: "/index/Client/search",
                    classify:'Client'
                }
                break;
            case 'ClientA'://客户
                this.tableHeadData = dataConfig.CustomConfig;
                this.searchData = { 
                    title: "客户/供应商",
                    url1: "/index/Client/getlist",
                    url2: "/index/Client/getAll",
                    url3: "/index/Client/search",
                    classify:'ClientA'
                }
                break;
            case 'ClientB'://供应商
                this.tableHeadData = dataConfig.CustomConfig;
                this.searchData = { 
                    title: "客户/供应商",
                    url1: "/index/Client/getlist",
                    url2: "/index/Client/getAll",
                    url3: "/index/Client/search",
                    classify:'ClientB'
                }
                break;
            case 'Stock'://仓库
                this.tableHeadData = dataConfig.WarehouseConfig;
                this.searchData = { 
                    title: "仓库",
                    url1: "/index/Stock/getlist",
                    url2: "/index/Stock/getAll",
                    url3: "/index/Stock/search",
                    classify:'Stock'
                }
                break;
            case 'Person'://经手人
                this.tableHeadData = dataConfig.HandlersConfig;
                this.searchData = { 
                    title: "经手人",
                    url1: "/index/Department/getlist",
                    url2: "/index/Person/getAll",
                    url3: "/index/Person/search",
                    classify:'Person'
                }
                break;
            case 'Department'://部门
                this.tableHeadData = dataConfig.DepartmentConfig;
                this.searchData = { 
                    title: "部门",
                    url1: "/index/Department/getlist",
                    url2: "/index/Department/getAll",
                    url3: "/index/Department/search",
                    classify:'Department'
                }
                break;
            case 'Area'://地区
                this.tableHeadData = dataConfig.AreaConfig;
                this.searchData = { 
                    title: "地区",
                    url1: "/index/Area/getlist",
                    url2: "/index/Area/getAll",
                    url3: "/index/Area/search",
                    classify:'Area'
                }
                break;
            // case ''://银行账户
            //     this.tableHeadData = dataConfig.CustomConfig;
            //     this.searchData = { 
            //         title: "银行账户",
            //         url1: "/index/Settings/get_other",
            //         url2: "/index/Settings/get_other",
            //         url3: "/index/Settings/search_other",
            //         classify:'Goods'
            //     }
            //     break;
            case 'Goods'://商品
                this.tableHeadData = dataConfig.CustomConfig;
                this.searchData = { 
                    title: "客户/供应商",
                    url1: "/index/Client/getlist",
                    url2: "/index/Client/getAll",
                    url3: "/index/Client/search",
                    classify:'Goods'
                }
                break;
            default:
                break;
        }
    },
    mounted(){

    }
};

</script>

<style lang="less">
.MaInput{
    .label_sty{
        color: #333;
        font-size: 12px;
        padding: 0 5px;
        height: 100%;
        line-height: 28px;
        font-weight: bold;
        display: inline-block;
    }
    // .el-input--prefix .el-input__inner{
    //     padding-left: 65px;
    // }
}

</style>


// WEBPACK FOOTER //
// src/components/Input/MaInput/MaInput.vue